import { render, staticRenderFns } from "./PinterestButton.vue?vue&type=template&id=03919b5f&scoped=true&"
import script from "./PinterestButton.vue?vue&type=script&lang=js&"
export * from "./PinterestButton.vue?vue&type=script&lang=js&"
import style0 from "./PinterestButton.vue?vue&type=style&index=0&id=03919b5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03919b5f",
  null
  
)

export default component.exports